import Vue from 'vue';
//require('dotenv').config({path: '/var/www/html/inkless-chamada/.env'});
require('dotenv').config();
import App from './App.vue';
import axiosApi from 'axios';
import moment from 'moment';

const debug = (level, message, details) => {
    const logger = console[level] || console.log;
    const prefix = `[Painel ${new Date().toISOString()}]`;

    if (typeof details === 'undefined') {
        logger.call(console, prefix, message);
        return;
    }

    logger.call(console, prefix, message, details);
};

const serverUrl = process.env.NODE_ENV === 'production'
    ? window.location.origin
    : process.env.VUE_APP_SOCKET || `${window.location.protocol}//${window.location.hostname}:3030`;

const axios = axiosApi.create({
    baseURL: serverUrl
});

window.axios = axios;
window.painelDebug = debug;
window.painelServerUrl = serverUrl;

debug('info', 'Aplicação iniciando', {
    environment: process.env.NODE_ENV,
    pageUrl: window.location.href,
    serverUrl,
    configuredSocketUrl: process.env.VUE_APP_SOCKET || null,
    online: navigator.onLine,
    userAgent: navigator.userAgent
});

window.addEventListener('online', () => debug('info', 'Navegador ficou online'));
window.addEventListener('offline', () => debug('warn', 'Navegador ficou offline'));
window.addEventListener('error', event => {
    debug('error', 'Erro JavaScript não tratado', {
        message: event.message,
        filename: event.filename,
        line: event.lineno,
        column: event.colno,
        stack: event.error && event.error.stack
    });
});
window.addEventListener('unhandledrejection', event => {
    const reason = event.reason;
    debug('error', 'Promise rejeitada sem tratamento', {
        message: reason && reason.message ? reason.message : String(reason),
        stack: reason && reason.stack
    });
});

axios.interceptors.request.use(config => {
    debug('debug', 'Requisição HTTP iniciada', {
        method: config.method && config.method.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL
    });
    return config;
});

axios.interceptors.response.use(response => {
    debug('debug', 'Resposta HTTP recebida', {
        status: response.status,
        url: response.config && response.config.url
    });
    return response;
}, error => {
    debug('error', 'Falha em requisição HTTP', {
        message: error.message,
        status: error.response && error.response.status,
        url: error.config && error.config.url
    });
    return Promise.reject(error);
});

moment.locale('pt-br')
window.moment = moment;

Vue.config.errorHandler = (error, vm, info) => {
    debug('error', 'Erro capturado pelo Vue', {
        message: error.message,
        stack: error.stack,
        component: vm && vm.$options && vm.$options.name,
        lifecycle: info
    });
};

new Vue({
    render: h => h(App)
}).$mount('#app');

debug('info', 'Aplicação montada no DOM');
